import React from "react";
import VideoComponent from "./video.component";
import Skeleton from "@material-ui/lab/Skeleton";
import PlayCircleFilledRoundedIcon from "@material-ui/icons/PlayCircleFilledRounded";
import { useSelector } from "react-redux";
import { getYoutubeIdByUrl } from "../../../utils/productPage.util";
import Alert from "@material-ui/lab/Alert";

function SkeletonFrame({ error = false, getTranslation }) {
  return (
    <div
      style={{
        backgroundColor: "white",
        border: "1px solid lightgrey",
        borderRadius: 10,
        marginRight: 16,
        marginLeft: 16,
        minHeight: "max-content",
        overflow: "hidden"
      }}
    >
      {error && (
        <div style={{ padding: 8 }}>
          <Alert severity="error">{getTranslation("message.error.YOUTUBE_URL_INVALID")}</Alert>
        </div>
      )}
      <Skeleton
        variant="rect"
        height={200}
        animation={false}
        style={{ position: "relative" }}
      >
        <PlayCircleFilledRoundedIcon
          fontSize="large"
          color="disabled"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          }}
        />
      </Skeleton>
    </div>
  );
}

export default function VideoContainer({ id, isTemplateEditor, getTranslation }) {
  const {
    isVisible,
    content: { URL }
  } = useSelector(state => isTemplateEditor
    ? state.products.template.workspaceSetting.setting.components[id]
    : state.productPage.components[id]);

  const youtubeId = getYoutubeIdByUrl(URL);
  const embedUrl = `https://www.youtube.com/embed/${youtubeId}`;

  if (!URL || !youtubeId)
    return <SkeletonFrame error={true} getTranslation={getTranslation}/>
  else
    return isVisible && <VideoComponent url={embedUrl} getTranslation={getTranslation} />
}
